// extracted by mini-css-extract-plugin
module.exports = {"root":"chart_root__1w831","checkbox":"chart_checkbox__2-NSk"};